import React from "react";
import "./V2Banner.scss";

const V2Banner = () => (
  <a
    className="v2-banner"
    href="https://arslankaleem.tech"
    rel="noopener noreferrer"
  >
    Try the new V2 design &rarr;
  </a>
);

export default V2Banner;
